/* eslint-disable no-underscore-dangle */
import PouchDB from 'pouchdb';
import { upsert, remove, bulkUpsert } from './common';
import {
  addOrUpdateOrderProduct,
  removeProductFromOrder,
  addMultipleProductsToOrder,
  isOrderEditable,
} from '../utils/order';
import { orderStatus } from '../constants';

class OrderStore {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  upsert = (key, data, onSuccess) => upsert(this.db, key, data, onSuccess);

  bulkUpsert = (data, onSuccess) => bulkUpsert(this.db, data, onSuccess);

  remove = (key, onRemove) => remove(this.db, key, onRemove);

  createOrder = (order, onSuccess) => {
    this.upsert(
      order.id,
      {
        _id: order.id,
        status: orderStatus.draft,
        ...order,
        orderDate: new Date(),
      },
      onSuccess
    );
  };

  createMultipleOrder = (orders, onSuccess) => {
    this.bulkUpsert(orders, onSuccess);
  };

  closeOrder = (id, order, onSuccess) => {
    this.upsert(
      id,
      {
        _id: id,
        ...order,
        salesforce_id: 'test',
        status: order.status,
      },
      onSuccess
    );
  };

  closeOrderButFailedToSync = (id, order, onSuccess) => {
    this.upsert(
      id,
      {
        _id: id,
        ...order,
        status: orderStatus.failedToSync,
      },
      onSuccess
    );
  };

  updateOrder = (id, order, onSuccess) => {
    if (!isOrderEditable(order)) return;
    this.upsert(
      id,
      {
        _id: id,
        ...order,
      },
      onSuccess
    );
  };

  onAddOrUpdateOrderProduct = ({ order, product, onSuccess }) => {
    if (!isOrderEditable(order)) return;
    const newOrderData = addOrUpdateOrderProduct({ order, product });
    this.upsert(
      order._id,
      {
        ...newOrderData,
      },
      onSuccess
    );
  };

  onAddMultipleProductsToOrder = ({ order, products, onSuccess }) => {
    if (!isOrderEditable(order)) return;
    const newOrderData = addMultipleProductsToOrder({ order, products });
    this.upsert(
      order._id,
      {
        ...newOrderData,
      },
      onSuccess
    );
  };

  removeProductFromOrder = ({ order, id, onSuccess = () => {} }) => {
    if (!isOrderEditable(order)) return;
    this.upsert(
      order._id,
      {
        ...order,
        products: removeProductFromOrder({
          products: order.products,
          id,
        }),
      },
      onSuccess
    );
  };

  getOrders = (callback) => {
    this.db
      .allDocs({ include_docs: true })
      .then((doc) => {
        callback(doc.rows);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };

  getOrder = (id, callback) => {
    this.db
      .get(id)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };
}

export default OrderStore;
